import { useMemo } from 'react'
import { Box, Text } from '@chakra-ui/react'

import { useCustomFormAnswer } from 'components/tools/CustomForm/components/Answers/contexts/CustomFormViewerQuestionManager/Provider'
import CustomFormCPFAnswer from './components/CustomFormCPFAnswer'
import CustomFormCTPSAnswer from './components/CustomFormCTPSAnswer'
import CustomFormPISAnswer from './components/CustomFormPISAnswer'

type KeyStringWithElement = {
  [key: string]: JSX.Element
}

export default function CustomFormDocumentsAnswer() {
  const { answer } = useCustomFormAnswer()

  const RenderEntityComponent = useMemo(() => {
    if (!answer.answer) return <Box />
    const possibleEntities: KeyStringWithElement = {
      CPF: <CustomFormCPFAnswer />,
      CTPS: <CustomFormCTPSAnswer />,
      PIS: <CustomFormPISAnswer />,
    }

    return possibleEntities[answer.entity as string]
  }, [])

  if (!answer.answer) {
    return (
      <Text variant="secondary" fontStyle="italic">
        Nenhum registro enviado
      </Text>
    )
  }

  return <Box>{RenderEntityComponent}</Box>
}
